export const NavIcon = () => {
  return (
    <svg width="27" height="4" viewBox="0 0 27 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.0733 2.30275L1.10623 3.55881C0.560314 3.58742 0.083876 3.15844 0.0552656 2.61252C0.0266553 2.0666 0.455642 1.59017 1.00156 1.56156L24.9687 0.305493C25.5146 0.276882 25.991 0.705869 26.0196 1.25179C26.0482 1.7977 25.6193 2.27414 25.0733 2.30275Z"
        fill="#140D0B"/>
    </svg>

  )
}